import {
  Discount,
  QuotationProductCreateSchema,
  QuotationProductEdit,
  QuotationReadonlyProductSchema
} from "../../types";
import {computeDiscountedValue} from "../../lib/utilities";
import {SurveyProductItemSchema, SurveyProductsSchema} from "../../../commons";
import getKColorResultContextKey from "../../../../utils/getKColorResultContextKey";


export const getPackagesToOrder = (quantity: number | null, minQty?: number) => {
  if (!quantity || !minQty)
    return null;
  const packages = Math.ceil(quantity / minQty);
  return `${packages} × ${minQty}`;
}

export const computeTotals = (
  quantity: number,
  minQty: number | undefined,
  price: number | undefined | null = 0,
  discount: Discount,
  updatedQuantity: number | null
) => {
  const getFullQuantity = (quantity: number, minQty: number | undefined) => {
    if (!minQty)
      return quantity;
    return Math.ceil(quantity / minQty) * minQty;
  }

  const newQuantity = getFullQuantity(updatedQuantity || quantity, minQty)
  const updatedTotal = newQuantity * price;
  const originalTotal = getFullQuantity(quantity, minQty) * price;

  let result = {original: originalTotal};
  const discountedTotals = {
    discounted: discount,
    discountedQuantityOnly: {type: 'no_discount'} as Discount,
  }
  Object.entries(discountedTotals).forEach(([key, d]) => {
    result = {
      ...result,
      [key]: computeDiscountedValue(updatedTotal, d, newQuantity, price),
    };
  });

  return result as {original: number, discounted: number, discountedQuantityOnly: number};
}
/*
TODO check where to add info about product package,
*/
export const getProductCode = (product: SurveyProductItemSchema) => {
  return product.isKcolor ? getKColorResultContextKey(product.product.code, product.kcolor_color_code, product.product.min_qty) : product.product.art_cod;
}


export const generateQuotationCreatePayload = (
  data: SurveyProductsSchema,
  edits: {[key: string]: QuotationProductEdit},
  kColorChosenPrice: "kerakoll" | "tintometer" | null,
  userData: any
): QuotationProductCreateSchema[] => {
  const r =  Object.entries(data)
    // .filter(({product: {art_cod: code}}) => !!edits[code]?.checked)
    .filter(([key, product])=> {
      const code = getProductCode(product, key);
      return !!edits[code!!]?.checked;
    })
    .map(([key, surveyProduct]) => {
      const {
        product,
        quantity,
        isKcc,
        isKcolor,
        kcolor_color_code
      } = surveyProduct;
      const code = getProductCode(surveyProduct, key);
      const {discount, quantity: updatedQuantity} = edits[code!!];
      const {original, discounted} = computeTotals(
        quantity,
        product.min_qty,
        product.prezzo,
        discount,
        updatedQuantity
      );
      const originalQuantity = !!product.min_qty
        ? Math.ceil(quantity / product.min_qty) * product.min_qty
        : quantity;
      const q = updatedQuantity ?? originalQuantity;
      return {
        product_id: isKcolor ? null : product.id,
        cod_product: surveyProduct.isKcolor ? null : surveyProduct.product.art_cod,
        product_des_it: surveyProduct.isKcolor ? surveyProduct.product.product_des : product.art_des_it,
        val_product_unitprice:
          isKcolor &&
          kColorChosenPrice === 'tintometer'
            && userData.role_type !== 'resale_tintometer'
            ? null : product.prezzo || 0,
        val_product_qt: originalQuantity,
        val_product_discountruletype: discount.type,
        product_min_qty: product.min_qty,
        product_resa: product.resa,
        val_product_unit_discprice: discounted !== original
          ? discounted / q
          : undefined,
        val_product_total_discountrule: discount.value,
        is_kcc: isKcc,
        is_kcolor: isKcolor,
        updatedQuantity: updatedQuantity,
        // Only for K-Color products
        kcolor_color_code: kcolor_color_code,
        kcolor_cod_prod_comm: surveyProduct.product.code,
        ...(isKcolor ? {kcolor_product_package: surveyProduct.product.min_qty}: {}),
        ...(surveyProduct.surveys ? {
          surveys: Array.from(surveyProduct.surveys)
        }: {})
      } as QuotationProductCreateSchema;
    }) as QuotationProductCreateSchema[]
  return r;
}